import i18n from '@/plugins/i18n';

interface ICountry {
  code: string;

  name: string;
}
export default class Country {
  code: string;

  name: string;

  get value() { return this.code; }

  get text() { return this.name; }

  constructor(o: ICountry) {
    this.code = o.code ?? '';
    this.name = i18n.tc(`code.country.${this.code}`);
  }
}

export const countries: Country[] = [
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AS', name: 'American Samoa' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AI', name: 'Anguilla' },
  { code: 'AQ', name: 'Antarctica' },
  { code: 'AG', name: 'Antigua and Barbuda' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AW', name: 'Aruba' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BM', name: 'Bermuda' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BA', name: 'Bosnia and Herzegovina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BV', name: 'Bouvet Island' },
  { code: 'BR', name: 'Brazil' },
  { code: 'IO', name: 'British Indian Ocean Territory' },
  { code: 'BN', name: 'Brunei Darussalam' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'CA', name: 'Canada' },
  { code: 'CV', name: 'Cape Verde' },
  { code: 'KY', name: 'Cayman Islands' },
  { code: 'CF', name: 'Central African Republic' },
  { code: 'TD', name: 'Chad' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: "People's Republic of China" },
  { code: 'CX', name: 'Christmas Island' },
  { code: 'CC', name: 'Cocos (Keeling) Islands' },
  { code: 'CO', name: 'Colombia' },
  { code: 'KM', name: 'Comoros' },
  { code: 'CG', name: 'Republic of the Congo' },
  { code: 'CD', name: 'Democratic Republic of the Congo' },
  { code: 'CK', name: 'Cook Islands' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CI', name: "Cote d'Ivoire" },
  { code: 'HR', name: 'Croatia' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czechia' },
  { code: 'DK', name: 'Denmark' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Egypt' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'GQ', name: 'Equatorial Guinea' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estonia' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'FK', name: 'Falkland Islands (Malvinas)' },
  { code: 'FO', name: 'Faroe Islands' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'GF', name: 'French Guiana' },
  { code: 'PF', name: 'French Polynesia' },
  { code: 'TF', name: 'French Southern Territories' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Republic of The Gambia' },
  { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GI', name: 'Gibraltar' },
  { code: 'GR', name: 'Greece' },
  { code: 'GL', name: 'Greenland' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GP', name: 'Guadeloupe' },
  { code: 'GU', name: 'Guam' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HM', name: 'Heard Island and McDonald Islands' },
  { code: 'VA', name: 'Holy See (Vatican City State)' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IN', name: 'India' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Islamic Republic of Iran' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italy' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JP', name: 'Japan' },
  { code: 'JO', name: 'Jordan' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KP', name: 'North Korea' },
  { code: 'KR', name: 'South Korea' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'LA', name: "Lao People's Democratic Republic" },
  { code: 'LV', name: 'Latvia' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LY', name: 'Libya' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MO', name: 'Macao' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MV', name: 'Maldives' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'MH', name: 'Marshall Islands' },
  { code: 'MQ', name: 'Martinique' },
  { code: 'MR', name: 'Mauritania' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'YT', name: 'Mayotte' },
  { code: 'MX', name: 'Mexico' },
  { code: 'FM', name: 'Micronesia, Federated States of' },
  { code: 'MD', name: 'Moldova, Republic of' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'MS', name: 'Montserrat' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NC', name: 'New Caledonia' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'NU', name: 'Niue' },
  { code: 'NF', name: 'Norfolk Island' },
  { code: 'MK', name: 'The Republic of North Macedonia' },
  { code: 'MP', name: 'Northern Mariana Islands' },
  { code: 'NO', name: 'Norway' },
  { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PW', name: 'Palau' },
  { code: 'PS', name: 'State of Palestine' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua New Guinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PN', name: 'Pitcairn' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RE', name: 'Reunion' },
  { code: 'RO', name: 'Romania' },
  { code: 'RU', name: 'Russian Federation' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'SH', name: 'Saint Helena' },
  { code: 'KN', name: 'Saint Kitts and Nevis' },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'PM', name: 'Saint Pierre and Miquelon' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'ST', name: 'Sao Tome and Principe' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SN', name: 'Senegal' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'SB', name: 'Solomon Islands' },
  { code: 'SO', name: 'Somalia' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
  { code: 'ES', name: 'Spain' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'SD', name: 'Sudan' },
  { code: 'SR', name: 'Suriname' },
  { code: 'SJ', name: 'Svalbard and Jan Mayen' },
  { code: 'SZ', name: 'Eswatini' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'SY', name: 'Syrian Arab Republic' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TJ', name: 'Tajikistan' },
  { code: 'TZ', name: 'United Republic of Tanzania' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TL', name: 'Timor-Leste' },
  { code: 'TG', name: 'Togo' },
  { code: 'TK', name: 'Tokelau' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad and Tobago' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TR', name: 'Türkiye' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TC', name: 'Turks and Caicos Islands' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States of America' },
  { code: 'UM', name: 'United States Minor Outlying Islands' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Viet Nam' },
  { code: 'VG', name: 'Virgin Islands, British' },
  { code: 'VI', name: 'Virgin Islands, U.S.' },
  { code: 'WF', name: 'Wallis and Futuna' },
  { code: 'EH', name: 'Western Sahara' },
  { code: 'YE', name: 'Yemen' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' },
  { code: 'AX', name: 'Åland Islands' },
  { code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
  { code: 'CW', name: 'Curaçao' },
  { code: 'GG', name: 'Guernsey' },
  { code: 'IM', name: 'Isle of Man' },
  { code: 'JE', name: 'Jersey' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'BL', name: 'Saint Barthélemy' },
  { code: 'MF', name: 'Saint Martin (French part)' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SX', name: 'Sint Maarten (Dutch part)' },
  { code: 'SS', name: 'South Sudan' },
  { code: 'XK', name: 'Kosovo' },
].map((o) => new Country(o));

export const dialCodeByCountry = new Map<string, string>([
  { dial_code: '+93', code: 'AF' },
  { dial_code: '+358', code: 'AX' },
  { dial_code: '+355', code: 'AL' },
  { dial_code: '+213', code: 'DZ' },
  { dial_code: '+1684', code: 'AS' },
  { dial_code: '+376', code: 'AD' },
  { dial_code: '+244', code: 'AO' },
  { dial_code: '+1264', code: 'AI' },
  { dial_code: '+672', code: 'AQ' },
  { dial_code: '+1268', code: 'AG' },
  { dial_code: '+54', code: 'AR' },
  { dial_code: '+374', code: 'AM' },
  { dial_code: '+297', code: 'AW' },
  { dial_code: '+61', code: 'AU' },
  { dial_code: '+43', code: 'AT' },
  { dial_code: '+994', code: 'AZ' },
  { dial_code: '+1242', code: 'BS' },
  { dial_code: '+973', code: 'BH' },
  { dial_code: '+880', code: 'BD' },
  { dial_code: '+1246', code: 'BB' },
  { dial_code: '+375', code: 'BY' },
  { dial_code: '+32', code: 'BE' },
  { dial_code: '+501', code: 'BZ' },
  { dial_code: '+229', code: 'BJ' },
  { dial_code: '+1441', code: 'BM' },
  { dial_code: '+975', code: 'BT' },
  { dial_code: '+591', code: 'BO' },
  { dial_code: '+387', code: 'BA' },
  { dial_code: '+267', code: 'BW' },
  { dial_code: '+55', code: 'BR' },
  { dial_code: '+246', code: 'IO' },
  { dial_code: '+673', code: 'BN' },
  { dial_code: '+359', code: 'BG' },
  { dial_code: '+226', code: 'BF' },
  { dial_code: '+257', code: 'BI' },
  { dial_code: '+855', code: 'KH' },
  { dial_code: '+237', code: 'CM' },
  { dial_code: '+1', code: 'CA' },
  { dial_code: '+238', code: 'CV' },
  { dial_code: '+ 345', code: 'KY' },
  { dial_code: '+236', code: 'CF' },
  { dial_code: '+235', code: 'TD' },
  { dial_code: '+56', code: 'CL' },
  { dial_code: '+86', code: 'CN' },
  { dial_code: '+61', code: 'CX' },
  { dial_code: '+61', code: 'CC' },
  { dial_code: '+57', code: 'CO' },
  { dial_code: '+269', code: 'KM' },
  { dial_code: '+242', code: 'CG' },
  { dial_code: '+243', code: 'CD' },
  { dial_code: '+682', code: 'CK' },
  { dial_code: '+506', code: 'CR' },
  { dial_code: '+225', code: 'CI' },
  { dial_code: '+385', code: 'HR' },
  { dial_code: '+53', code: 'CU' },
  { dial_code: '+357', code: 'CY' },
  { dial_code: '+420', code: 'CZ' },
  { dial_code: '+45', code: 'DK' },
  { dial_code: '+253', code: 'DJ' },
  { dial_code: '+1767', code: 'DM' },
  { dial_code: '+1849', code: 'DO' },
  { dial_code: '+593', code: 'EC' },
  { dial_code: '+20', code: 'EG' },
  { dial_code: '+503', code: 'SV' },
  { dial_code: '+240', code: 'GQ' },
  { dial_code: '+291', code: 'ER' },
  { dial_code: '+372', code: 'EE' },
  { dial_code: '+251', code: 'ET' },
  { dial_code: '+500', code: 'FK' },
  { dial_code: '+298', code: 'FO' },
  { dial_code: '+679', code: 'FJ' },
  { dial_code: '+358', code: 'FI' },
  { dial_code: '+33', code: 'FR' },
  { dial_code: '+594', code: 'GF' },
  { dial_code: '+689', code: 'PF' },
  { dial_code: '+241', code: 'GA' },
  { dial_code: '+220', code: 'GM' },
  { dial_code: '+995', code: 'GE' },
  { dial_code: '+49', code: 'DE' },
  { dial_code: '+233', code: 'GH' },
  { dial_code: '+350', code: 'GI' },
  { dial_code: '+30', code: 'GR' },
  { dial_code: '+299', code: 'GL' },
  { dial_code: '+1473', code: 'GD' },
  { dial_code: '+590', code: 'GP' },
  { dial_code: '+1671', code: 'GU' },
  { dial_code: '+502', code: 'GT' },
  { dial_code: '+44', code: 'GG' },
  { dial_code: '+224', code: 'GN' },
  { dial_code: '+245', code: 'GW' },
  { dial_code: '+595', code: 'GY' },
  { dial_code: '+509', code: 'HT' },
  { dial_code: '+379', code: 'VA' },
  { dial_code: '+504', code: 'HN' },
  { dial_code: '+852', code: 'HK' },
  { dial_code: '+36', code: 'HU' },
  { dial_code: '+354', code: 'IS' },
  { dial_code: '+91', code: 'IN' },
  { dial_code: '+62', code: 'ID' },
  { dial_code: '+98', code: 'IR' },
  { dial_code: '+964', code: 'IQ' },
  { dial_code: '+353', code: 'IE' },
  { dial_code: '+44', code: 'IM' },
  { dial_code: '+972', code: 'IL' },
  { dial_code: '+39', code: 'IT' },
  { dial_code: '+1876', code: 'JM' },
  { dial_code: '+81', code: 'JP' },
  { dial_code: '+44', code: 'JE' },
  { dial_code: '+962', code: 'JO' },
  { dial_code: '+77', code: 'KZ' },
  { dial_code: '+254', code: 'KE' },
  { dial_code: '+686', code: 'KI' },
  { dial_code: '+850', code: 'KP' },
  { dial_code: '+82', code: 'KR' },
  { dial_code: '+965', code: 'KW' },
  { dial_code: '+996', code: 'KG' },
  { dial_code: '+856', code: 'LA' },
  { dial_code: '+371', code: 'LV' },
  { dial_code: '+961', code: 'LB' },
  { dial_code: '+266', code: 'LS' },
  { dial_code: '+231', code: 'LR' },
  { dial_code: '+218', code: 'LY' },
  { dial_code: '+423', code: 'LI' },
  { dial_code: '+370', code: 'LT' },
  { dial_code: '+352', code: 'LU' },
  { dial_code: '+853', code: 'MO' },
  { dial_code: '+389', code: 'MK' },
  { dial_code: '+261', code: 'MG' },
  { dial_code: '+265', code: 'MW' },
  { dial_code: '+60', code: 'MY' },
  { dial_code: '+960', code: 'MV' },
  { dial_code: '+223', code: 'ML' },
  { dial_code: '+356', code: 'MT' },
  { dial_code: '+692', code: 'MH' },
  { dial_code: '+596', code: 'MQ' },
  { dial_code: '+222', code: 'MR' },
  { dial_code: '+230', code: 'MU' },
  { dial_code: '+262', code: 'YT' },
  { dial_code: '+52', code: 'MX' },
  { dial_code: '+691', code: 'FM' },
  { dial_code: '+373', code: 'MD' },
  { dial_code: '+377', code: 'MC' },
  { dial_code: '+976', code: 'MN' },
  { dial_code: '+382', code: 'ME' },
  { dial_code: '+1664', code: 'MS' },
  { dial_code: '+212', code: 'MA' },
  { dial_code: '+258', code: 'MZ' },
  { dial_code: '+95', code: 'MM' },
  { dial_code: '+264', code: 'NA' },
  { dial_code: '+674', code: 'NR' },
  { dial_code: '+977', code: 'NP' },
  { dial_code: '+31', code: 'NL' },
  { dial_code: '+599', code: 'BQ' },
  { dial_code: '+599', code: 'CW' },
  { dial_code: '+721', code: 'SX' },
  { dial_code: '+687', code: 'NC' },
  { dial_code: '+64', code: 'NZ' },
  { dial_code: '+505', code: 'NI' },
  { dial_code: '+227', code: 'NE' },
  { dial_code: '+234', code: 'NG' },
  { dial_code: '+683', code: 'NU' },
  { dial_code: '+672', code: 'NF' },
  { dial_code: '+1670', code: 'MP' },
  { dial_code: '+47', code: 'NO' },
  { dial_code: '+968', code: 'OM' },
  { dial_code: '+92', code: 'PK' },
  { dial_code: '+680', code: 'PW' },
  { dial_code: '+970', code: 'PS' },
  { dial_code: '+507', code: 'PA' },
  { dial_code: '+675', code: 'PG' },
  { dial_code: '+595', code: 'PY' },
  { dial_code: '+51', code: 'PE' },
  { dial_code: '+63', code: 'PH' },
  { dial_code: '+872', code: 'PN' },
  { dial_code: '+48', code: 'PL' },
  { dial_code: '+351', code: 'PT' },
  { dial_code: '+1939', code: 'PR' },
  { dial_code: '+974', code: 'QA' },
  { dial_code: '+40', code: 'RO' },
  { dial_code: '+7', code: 'RU' },
  { dial_code: '+250', code: 'RW' },
  { dial_code: '+262', code: 'RE' },
  { dial_code: '+590', code: 'BL' },
  { dial_code: '+290', code: 'SH' },
  { dial_code: '+1869', code: 'KN' },
  { dial_code: '+1758', code: 'LC' },
  { dial_code: '+590', code: 'MF' },
  { dial_code: '+508', code: 'PM' },
  { dial_code: '+1784', code: 'VC' },
  { dial_code: '+685', code: 'WS' },
  { dial_code: '+378', code: 'SM' },
  { dial_code: '+239', code: 'ST' },
  { dial_code: '+966', code: 'SA' },
  { dial_code: '+221', code: 'SN' },
  { dial_code: '+381', code: 'RS' },
  { dial_code: '+248', code: 'SC' },
  { dial_code: '+232', code: 'SL' },
  { dial_code: '+65', code: 'SG' },
  { dial_code: '+421', code: 'SK' },
  { dial_code: '+386', code: 'SI' },
  { dial_code: '+677', code: 'SB' },
  { dial_code: '+252', code: 'SO' },
  { dial_code: '+27', code: 'ZA' },
  { dial_code: '+211', code: 'SS' },
  { dial_code: '+500', code: 'GS' },
  { dial_code: '+34', code: 'ES' },
  { dial_code: '+94', code: 'LK' },
  { dial_code: '+249', code: 'SD' },
  { dial_code: '+597', code: 'SR' },
  { dial_code: '+47', code: 'SJ' },
  { dial_code: '+268', code: 'SZ' },
  { dial_code: '+46', code: 'SE' },
  { dial_code: '+41', code: 'CH' },
  { dial_code: '+963', code: 'SY' },
  { dial_code: '+886', code: 'TW' },
  { dial_code: '+992', code: 'TJ' },
  { dial_code: '+255', code: 'TZ' },
  { dial_code: '+66', code: 'TH' },
  { dial_code: '+670', code: 'TL' },
  { dial_code: '+228', code: 'TG' },
  { dial_code: '+690', code: 'TK' },
  { dial_code: '+676', code: 'TO' },
  { dial_code: '+1868', code: 'TT' },
  { dial_code: '+216', code: 'TN' },
  { dial_code: '+90', code: 'TR' },
  { dial_code: '+993', code: 'TM' },
  { dial_code: '+1649', code: 'TC' },
  { dial_code: '+688', code: 'TV' },
  { dial_code: '+256', code: 'UG' },
  { dial_code: '+380', code: 'UA' },
  { dial_code: '+971', code: 'AE' },
  { dial_code: '+44', code: 'GB' },
  { dial_code: '+1', code: 'US' },
  { dial_code: '+598', code: 'UY' },
  { dial_code: '+998', code: 'UZ' },
  { dial_code: '+678', code: 'VU' },
  { dial_code: '+58', code: 'VE' },
  { dial_code: '+84', code: 'VN' },
  { dial_code: '+1284', code: 'VG' },
  { dial_code: '+1340', code: 'VI' },
  { dial_code: '+681', code: 'WF' },
  { dial_code: '+967', code: 'YE' },
  { dial_code: '+260', code: 'ZM' },
  { dial_code: '+263', code: 'ZW' },
].map((o) => [o.code, o.dial_code]));
